export const PAGE_ACCESS = [
  { key: "dashboard", label: "Overview", path: "/dashboard" },
  { key: "clients", label: "Clients", path: "/clients" },
  { key: "events", label: "Event planner", path: "/events" },
  { key: "finance", label: "Payments", path: "/finance" },
  { key: "team", label: "Team", path: "/team" },
  { key: "selections", label: "Photo selections", path: "/transfers/history" },
  { key: "galleries", label: "Edited galleries", path: "/galleries/new" },
  { key: "settings", label: "Profile", path: "/settings" },
];

export const hasPageAccess = (user, pageKey) =>
  pageKey === "galleryCreation"
    ? user?.role === "owner" || (!user?.trialExpired && (!user?.accessConfigured || ["selections", "galleries"].some((key) => (user?.pageAccess || []).includes(key))))
    :
  user?.role === "owner" ||
  (!user?.trialExpired && (!user?.accessConfigured || (user?.pageAccess || []).includes(pageKey)));

export const firstAccessiblePath = (user) =>
  PAGE_ACCESS.find((page) => hasPageAccess(user, page.key))?.path || "/access-pending";
